import { ref } from 'vue';
const isSidebarCollapsed = ref(localStorage.getItem('sidebarCollapsed') === 'true');
const isMobileSidebarOpen = ref(false);
export function toggleSidebar() {
    isSidebarCollapsed.value = !isSidebarCollapsed.value;
    localStorage.setItem('sidebarCollapsed', isSidebarCollapsed.value.toString());
}
export function toggleMobileSidebar() {
    isMobileSidebarOpen.value = !isMobileSidebarOpen.value;
}
export function closeMobileSidebar() {
    isMobileSidebarOpen.value = false;
}
export function getSidebarState() {
    return isSidebarCollapsed;
}
export function getMobileSidebarState() {
    return isMobileSidebarOpen;
}
